(function () {
  var dialog = document.getElementById('fits-market-choice-dialog');
  var root = document.documentElement;
  var preferenceKey = 'fitsMarketChoice';
  var preferenceLifetime = 30 * 24 * 60 * 60 * 1000;

  if (!dialog) {
    root.classList.remove('fits-market-choice-pending');
    return;
  }

  var currentStore = dialog.dataset.currentStore;
  var currentCountry = dialog.dataset.currentCountry || currentStore;
  var localizationForm = document.getElementById('MarketChoiceLocalization');
  var countrySelect = localizationForm && localizationForm.querySelector('[name="country_code"]');
  if (countrySelect && typeof Intl !== 'undefined' && Intl.DisplayNames) {
    var regionNames = new Intl.DisplayNames([dialog.lang || 'en'], { type: 'region' });
    Array.prototype.forEach.call(countrySelect.options, function (option) {
      option.textContent = regionNames.of(option.value) + ' — ' + option.dataset.currency;
    });
  }
  var pageUrl = new URL(window.location.href);
  var preview = pageUrl.searchParams.get('market_choice_preview') === '1';
  var arrivingWithChoice = pageUrl.searchParams.get('market_choice') === currentCountry;

  // Shopify provides the translated handle on its alternate-language links.
  // Never construct product destinations by swapping the hostname alone.
  function alternateUrl(countryCode) {
    var storefronts = {
      DK: { host: 'www.xn--retrotrjer-6cb.dk', language: 'da' },
      GB: { host: 'www.retrofootballstore.co.uk', language: 'en' },
      SE: { host: 'www.retrofootballstore.se', language: 'sv' },
      DE: { host: 'www.retrofootballstore.de', language: 'de' }
    };
    var storefront = storefronts[countryCode];
    if (!storefront) return null;
    var alternates = document.querySelectorAll('link[rel="alternate"][hreflang][href]');
    for (var i = 0; i < alternates.length; i++) {
      var url = new URL(alternates[i].href, window.location.origin);
      var language = alternates[i].getAttribute('hreflang').toLowerCase();
      var matchesLanguage = language === storefront.language
        || language.indexOf(storefront.language + '-') === 0;
      if (url.protocol === 'https:' && url.hostname === storefront.host && matchesLanguage) {
        return url;
      }
    }
    return null;
  }

  function availableCountry(countryCode) {
    return countrySelect && Array.prototype.some.call(countrySelect.options, function (option) {
      return option.value === countryCode && !option.disabled;
    });
  }

  function notifyResolved() {
    root.classList.remove('fits-market-choice-pending', 'fits-market-choice-active');
    document.dispatchEvent(new CustomEvent('fits:market-choice-resolved'));
  }

  function rememberChoice(countryCode) {
    try {
      localStorage.setItem(preferenceKey, JSON.stringify({
        country: countryCode,
        expires: Date.now() + preferenceLifetime
      }));
    } catch (error) {
      // Continue without persistence when storage is unavailable.
    }
  }

  function hasRememberedChoice() {
    try {
      var preference = JSON.parse(localStorage.getItem(preferenceKey));
      return Boolean(preference && preference.country && preference.expires > Date.now());
    } catch (error) {
      return false;
    }
  }

  function stayOnStore() {
    rememberChoice(currentCountry);
    if (dialog.open && typeof dialog.close === 'function') dialog.close();
    else dialog.removeAttribute('open');
    notifyResolved();
  }

  function switchStore(event) {
    var selectedCountry = countrySelect.value;
    if (!availableCountry(selectedCountry) || selectedCountry === currentCountry) {
      event.preventDefault();
      stayOnStore();
      return;
    }

    rememberChoice(selectedCountry);
    var destination = alternateUrl(selectedCountry);
    var returnUrl = new URL(pageUrl.toString());
    returnUrl.searchParams.delete('market_choice_preview');
    returnUrl.searchParams.set('market_choice', selectedCountry);
    returnUrl.searchParams.set('country', selectedCountry);

    if (destination) {
      event.preventDefault();
      // Retain product variants, collection filters and campaign attribution.
      returnUrl.searchParams.forEach(function (value, key) { destination.searchParams.delete(key); });
      returnUrl.searchParams.forEach(function (value, key) { destination.searchParams.append(key, value); });
      destination.searchParams.set('country', selectedCountry);
      destination.hash = returnUrl.hash;
      window.location.assign(destination.toString());
      return;
    }

    // For every other active region, Shopify resolves the market, currency and
    // translated resource through its localization form. Do not invent URLs.
    var returnTo = localizationForm.querySelector('[name="return_to"]');
    if (returnTo) returnTo.value = returnUrl.pathname + returnUrl.search + returnUrl.hash;
  }

  if (localizationForm && countrySelect) {
    localizationForm.addEventListener('submit', switchStore);
  }
  dialog.querySelectorAll('[data-market-choice="stay"]').forEach(function (button) {
    button.addEventListener('click', stayOnStore);
  });

  dialog.addEventListener('cancel', function (event) {
    event.preventDefault();
    stayOnStore();
  });

  // Cross-domain localization can encounter an older country cookie on arrival.
  // Reapply the explicitly selected country once, without redirecting browsers
  // merely because of their location or language.
  var requestedCountry = pageUrl.searchParams.get('market_choice');
  if (availableCountry(requestedCountry) && requestedCountry !== currentCountry
    && pageUrl.searchParams.get('country') !== requestedCountry) {
    pageUrl.searchParams.set('country', requestedCountry);
    window.location.replace(pageUrl.toString());
    return;
  }

  if (arrivingWithChoice) {
    rememberChoice(currentCountry);
    pageUrl.searchParams.delete('market_choice');
    window.history.replaceState(window.history.state, '', pageUrl.toString());
  }

  function showChoice(countryCode) {
    if (availableCountry(countryCode)) countrySelect.value = countryCode;
    root.classList.remove('fits-market-choice-pending');
    root.classList.add('fits-market-choice-active');
    if (typeof dialog.showModal === 'function') {
      dialog.showModal();
    } else {
      dialog.setAttribute('open', '');
    }
  }

  if (!countrySelect || countrySelect.options.length < 2) {
    notifyResolved();
    return;
  }

  if (preview) {
    showChoice();
    return;
  }

  if (arrivingWithChoice) {
    notifyResolved();
    return;
  }

  if (hasRememberedChoice() || !window.Shopify) {
    notifyResolved();
    return;
  }

  // Shopify removes /en/ before the theme loads. Navigation Timing can reveal
  // a redirect, but cannot distinguish old English links from Danish aliases.
  var navigation = window.performance && typeof window.performance.getEntriesByType === 'function'
    ? window.performance.getEntriesByType('navigation')[0]
    : null;
  if (currentStore === 'DK' && dialog.dataset.pageType === 'product' && navigation && navigation.redirectCount > 0) {
    showChoice();
    return;
  }

  var preferredLanguage = (navigator.languages && navigator.languages[0]) || navigator.language || '';
  if (currentStore === 'DK' && /^en(?:-|$)/i.test(preferredLanguage)) {
    showChoice();
    return;
  }

  var rootUrl = window.Shopify.routes && window.Shopify.routes.root
    ? window.Shopify.routes.root
    : '/';
  var suggestionUrl = rootUrl
    + 'browsing_context_suggestions.json'
    + '?country[enabled]=true&country[exclude]=' + currentCountry;

  var controller = new AbortController();
  var timeout = window.setTimeout(function () { controller.abort(); }, 4000);

  fetch(suggestionUrl, { headers: { Accept: 'application/json' }, signal: controller.signal })
    .then(function (response) {
      if (!response.ok) throw new Error('Location suggestion request failed');
      return response.json();
    })
    .then(function (data) {
      var detectedCountry = data
        && data.detected_values
        && data.detected_values.country
        && data.detected_values.country.handle;

      window.clearTimeout(timeout);
      if (!availableCountry(detectedCountry) || detectedCountry === currentCountry) {
        notifyResolved();
        return;
      }

      showChoice(detectedCountry);
    })
    .catch(function () {
      window.clearTimeout(timeout);
      notifyResolved();
    });
})();
